import React, { useState } from "react";
import { Check, Minus, ChevronRight, ChevronDown, Plus } from "lucide-react";

const plans = [
  {
    name: "Loyalty",
    key: "build", // <-- ADD THIS
    color: "bg-white",
    text: "text-black",
    button: "border border-[#5F3DC4] text-[#5F3DC4]",
  },
  {
    name: "Ordering",
    key: "elevate",
    color: "bg-white",
    text: "text-black",
    button: "border border-[#5F3DC4] text-[#5F3DC4]",
  },
  {
    name: "Ultimate",
    key: "innovate",
    color: "bg-[#5F3DC4]",
    text: "text-white",
    button: "bg-pink-400 text-white",
  },
];

const features = [
  {
    section: "Digital consultations",
    items: [
      {
        label: "Create consultation forms with the Consult app for iOS",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Send electronic forms before appointments",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Save consultation forms to customer profiles in Timely",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Set up consultation forms to send automatically",
        build: false,
        elevate: false,
        innovate: true,
      },
    ],
  },
  {
    section: "Client management",
    items: [
      {
        label: "Client login for managing and rebooking appointments",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Create exclusive VIP client services",
        build: false,
        elevate: false,
        innovate: true,
      },
      {
        label: "Allow customers to bulk buy services as a package",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Group services that you would normally perform together",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Client appointment reminders",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Client’s appointment history",
        build: true,
        elevate: true,
        innovate: true,
      },
      { label: "Client profiles", build: true, elevate: true, innovate: true },
      {
        label: "Before and after photos",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Scan or upload documents to client profiles",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Add notes to client profiles",
        build: true,
        elevate: true,
        innovate: true,
      },
      { label: "Loyalty rewards", build: false, elevate: true, innovate: true },
      {
        label: "Advanced rewards",
        build: false,
        elevate: false,
        innovate: true,
      },
      {
        label: "Appointment confirmations by email and SMS",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "One-off email and SMS messaging",
        build: true,
        elevate: true,
        innovate: true,
      },
    ],
  },
  {
    section: "Client loyalty",
    items: [
      {
        label: "Rebooking reminders and reconnect messages",
        build: false,
        elevate: false,
        innovate: true,
      },
      {
        label: "Send thank you messages",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Request reviews from clients",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Send aftercare and follow-up instructions",
        build: false,
        elevate: true,
        innovate: true,
      },
    ],
  },
  {
    section: "Staff management",
    items: [
      {
        label: "Set tiered pricing depending on staff experience",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Track staff performance and dashboard",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Set weekly and monthly staff targets",
        build: false,
        elevate: false,
        innovate: true,
      },
      {
        label: "Let staff manage clients and appointments through the app",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Manage timesheets and rosters",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label:
          "Keep staff up to date automatically with appointment notifications",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Assign and control staff access and logins",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Admin logins for administrators and non-booking staff",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Track activity log",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Pin access and device security",
        build: true,
        elevate: true,
        innovate: true,
      },
    ],
  },
  {
    section: "Reporting & analytics",
    items: [
      {
        label: "Business performance reports",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Financial reports and dashboard",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Stock, appointment, client and staff reports",
        build: true,
        elevate: true,
        innovate: true,
      },
    ],
  },
  {
    section: "Stock & inventory",
    items: [
      {
        label: "Retail and professional stock management",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Order stock directly from suppliers",
        build: false,
        elevate: true,
        innovate: true,
      },
      {
        label: "Use the Timely Stock app",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Connect the Timely Stock app to Timely",
        build: false,
        elevate: true,
        innovate: true,
      },
    ],
  },
  {
    section: "Add-ons",
    items: [
      {
        label: "Accounting integrations - Xero, MYOB and Quickbooks",
        build: true,
        elevate: true,
        innovate: true,
      },
      { label: "Stripe", build: false, elevate: true, innovate: true },
      {
        label: "Connect to any website, including Squarespace and Wix",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Run marketing campaigns with Mailchimp",
        build: true,
        elevate: true,
        innovate: true,
      },
    ],
  },
  {
    section: "Business admin",
    items: [
      {
        label: "Security to keep sensitive data secure",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Track incomings and outgoings with cash management",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Create and manage multiple locations",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Automate admin with Zapier API",
        build: false,
        elevate: false,
        innovate: true,
      },
    ],
  },
  {
    section: "Onboarding and support from Timely",
    items: [
      {
        label: "Resources, business guides, and Timely Learn",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Online support, help centre, chatbot and live messaging",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Call back and phone support",
        build: false,
        elevate: false,
        innovate: true,
      },
      {
        label: "Direct phone support",
        build: "$30 per month",
        elevate: "$30 per month",
        innovate: true,
      },
      {
        label: "Online training",
        build: false,
        elevate: false,
        innovate: true,
      },
      {
        label: "Transfer data from your current system",
        build: false,
        elevate: false,
        innovate: true,
      },
    ],
  },
  {
    section: "Included SMS and rates",
    items: [
      {
        label: "Included monthly SMS per staff (excludes targeted SMS)",
        build: "100 SMS",
        elevate: "150 SMS",
        innovate: "200 SMS",
      },
      {
        label: "Rates for excess SMS",
        build: "10c per SMS",
        elevate: "10c per SMS",
        innovate: "10c per SMS",
      },
    ],
  },
  {
    section: "Customer support",
    items: [
      {
        label: "Email (Typical response 24 hours)",
        build: true,
        elevate: true,
        innovate: true,
      },
      {
        label: "Premium support (24/7 phone and chat support)",
        build: false,
        elevate: "NZ$44.95 monthly",
        innovate: <span className="text-purple-600 font-semibold">Free</span>,
      },
    ],
  },
];

const renderCell = (value) => {
  if (value === true) return <Check className="w-5 h-5 mx-auto text-text" />;
  if (value === false)
    return <Minus className="w-5 h-5 mx-auto text-textGray" />;
  if (typeof value === "string" || typeof value === "number")
    return <div className="text-center">{value}</div>;
  return value;
};

export default function ComparePlansOrdering() {
  const [openSections, setOpenSections] = useState({});
  const [activePlan, setActivePlan] = useState("Build");

  const toggleSection = (idx) => {
    setOpenSections((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };

  return (
    <div className="bg-black p-4 mx-auto">
      {/* Mobile tabs */}

      <div className="block md:hidden  sticky top-16 z-50 bg-black my-4 ">
        <div className="flex justify-center gap-8 border-b border-border ">
          {plans.map((plan) => (
            <button
              key={plan.key}
              onClick={() => setActivePlan(plan.key)}
              className="relative py-2 font-semibold text-sm text-white"
            >
              <div className="flex items-center">
                {plan.name === "Innovate" && (
                  <span className="text-redlight mr-1">★</span>
                )}
                {plan.name}
              </div>
              {activePlan === plan.key && (
                <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-redlight transition-all duration-300"></div>
              )}
            </button>
          ))}
        </div>
        <button className="my-2 px-4 py-2 rounded-full text-sm font-semibold border border-redlight text-redlight w-full">
          Get started
        </button>
      </div>

      {/* Desktop header */}
      <div className="max-w-6xl mx-auto">
        <div className="hidden md:grid grid-cols-4 sticky top-16 z-50 border-b border-border mb-0">
          <div className="bg-black"></div>
          {plans.map((plan) => (
            <div
              key={plan.key}
              className="p-4 text-center font-bold text-text bg-black"
            >
              <div className="text-xl">{plan.name}</div>
              <button className="mt-2 px-4 py-1 rounded-full text-sm font-semibold border border-redlight text-redlight">
                Get started
              </button>
            </div>
          ))}
        </div>
        {/* Mobile feature list */}
        <div className="block md:hidden">
          <div
            key={activePlan}
            className="transition duration-500 transform "
            data-aos="fade-right"
          >
            {features.map((section, idx) => (
              <div key={idx} className="my-3">
                <div
                  onClick={() => toggleSection(idx)}
                  className="cursor-pointer py-2 hover:bg-dry transition flex justify-start items-center bg-black text-text border-t border-border"
                >
                  <div className="mr-2">
                    {openSections[idx] ? <Minus /> : <Plus />}
                  </div>
                  <div className="font-semibold">{section.section}</div>
                </div>

                {openSections[idx] && (
                  <div className="space-y-3">
                    {section.items.map((item, i) => (
                      <div
                        key={i}
                        className="flex justify-between text-sm bg-[#1f1f1f] p-3 rounded-lg text-white grid grid-cols-2 md:hidden items-center py-3 px-4 text-text"
                      >
                        <div>{item.label}</div>
                        <div>{renderCell(item[activePlan])}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Features */}
        <div className="hidden md:block">
          {features.map((section, idx) => (
            <div key={idx} className="border-b border-border bg-black">
              {/* Section Title */}
              <div
                onClick={() => toggleSection(idx)}
                className="cursor-pointer p-4 hover:bg-dry transition flex justify-start items-center bg-black text-text"
                data-aos="fade-left"
              >
                <div className="font-bold text-xl mr-2">
                  {openSections[idx] ? <Minus /> : <Plus />}
                </div>
                <div className="font-semibold">{section.section}</div>
              </div>

              {openSections[idx] &&
                section.items.map((item, i) => (
                  <div key={i} className="border-t border-border text-sm">
                    {/* Desktop view: full 3 columns */}
                    <div className="hidden md:grid grid-cols-4 items-center py-3 px-4 text-textGray">
                      <div>{item.label}</div>
                      {plans.map((plan) => (
                        <div key={plan.key}>{renderCell(item[plan.key])}</div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
